import { render } from "./quiz-v1-results.vue?vue&type=template&id=122bb553&scoped=true"
import script from "./quiz-v1-results.vue?vue&type=script&lang=js"
export * from "./quiz-v1-results.vue?vue&type=script&lang=js"

import "./quiz-v1-results.vue?vue&type=style&index=0&id=122bb553&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122bb553"]])

export default __exports__